import { render, staticRenderFns } from "./BaseTLTest.vue?vue&type=template&id=b669e8c0&"
import script from "./BaseTLTest.vue?vue&type=script&lang=ts&"
export * from "./BaseTLTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports